import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { authClient } from '@/lib/auth-client';
import Loader from './loader';

interface AuthGuardProps {
  children: React.ReactNode;
  requireAuth?: boolean; // true = precisa estar logado, false = precisa estar deslogado
  redirectTo?: string;
}

export default function AuthGuard({
  children,
  requireAuth = true,
  redirectTo,
}: AuthGuardProps) {
  const { data: session, isPending } = authClient.useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (isPending) return; // Aguarda carregamento da sessão

    const isAuthenticated = !!session;

    if (requireAuth && !isAuthenticated) {
      // Usuário precisa estar logado mas não está
      navigate({
        to: '/login',
        search: { redirect: window.location.pathname },
      });
    } else if (!requireAuth && isAuthenticated) {
      // Usuário precisa estar deslogado mas está logado
      navigate({
        to: redirectTo || '/dashboard',
      });
    }
  }, [session, isPending, requireAuth, redirectTo, navigate]);

  // Mostra loader enquanto verifica autenticação
  if (isPending) {
    return <Loader />;
  }

  // Se as condições de auth estão corretas, renderiza os children
  const isAuthenticated = !!session;
  const shouldRender = requireAuth ? isAuthenticated : !isAuthenticated;

  return shouldRender ? <>{children}</> : <Loader />;
}
